<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-select
        v-model="value"
        @change="changeDateFormatData"
        style="width: 120px"
      >
        <el-option
          v-for="item in dateFormatOptions"
          :key="item.dateFormatId"
          :label="item.label"
          :value="item.dateFormatId"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="tableParams.appBundleOrAppNameOrChannel"

        clearable
        placeholder="请输入应用包名/应用名称/渠道号"
        style="width: 270px"
        @input="
          removeBlank(
            tableParams.appBundleOrAppNameOrChannel,
            'appBundleOrAppNameOrChannel'
          )
        "
      />
      <search-dsp-select v-model="tableParams.dspId" />
      <base-date-picker @changeDate="changeDate" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel(
              '/webReportKeyword/Application/list/csv',
              '应用报表',
              tableParams
            )
          "
          type="warning"
          size="small"
          >下载</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        :load="load"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
        @sort-change="sortChange"
      >
        <el-table-column
          v-if="tableParams.showType === 1 || 2"
          prop="timeKey"
          :label="tableParams.showType === 1 ? '日期' : '时间'"
          sortable
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
          :sortable="
            v.field === 'showSmt' ||
            v.field === 'reportTime' ||
            v.field === 'contactPhone' ||
            v.field === 'hit' ||
            v.field === 'win' ||
            v.field === 'winPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'clkSmt' ||
            v.field === 'expensesEcpm' ||
            v.field === 'expensesAge' ||
            v.field === 'incomeEcpm' ||
            v.field === 'incomeAge' ||
            v.field === 'clkAvg'
          "
        >
          <template v-slot="scope">
            <el-tag
              v-if="v.field === 'clickRate' && scope.row[v.field] != 0"
              type="info"
              >{{ scope.row[v.field] ? scope.row[v.field] + "%" : "" }}</el-tag
            >
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import { uuid } from '@/util/util'
import { fetchApplicationDetailList } from "@/api/manage/keyword/appReport";


export default {
  name: 'Manage/keyword/appReport',
  components: {
    TableColumn,
    SearchDspSelect,
    BaseDatePicker
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: 'appBundle', title: '应用包名' },
        { field: 'appName', title: '应用名称' },
        { field: 'oppoChannel', title: '渠道号' },
        { field: 'dspName', title: 'DSP名称' },
        // { field: 'dspType', title: '请求数' },
        { field: 'hit', title: '命中数' },
        { field: 'win', title: '胜出数' },
        { field: 'showSmt', title: '展示数' },
        { field: 'clkSmt', title: '点击数' },
        { field: 'clickRate', title: '点击率' },
        { field: 'expensesEcpm', title: '支出ecpm' },
        { field: 'auctionPrice', title: '支出' },
        { field: 'expensesAge', title: '支出均价' },
        { field: 'incomeEcpm', title: '收入ecpm' },
        { field: 'winPrice', title: '收入' },
        { field: 'incomeAge', title: '收入均价' }

        // { field: 'contactPhone', title: '下载数' },
      ],
      dateFormatOptions: [
        {
          dateFormatId: 0,
          label: '正常显示'
        },
        {
          dateFormatId: 1,
          label: '按日显示'
        },
        {
          dateFormatId: 2,
          label: '按小时显示'
        },
      ],
      value: 0,
      type: "",
      tey: false,
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  provide() {
    return {
      init: this.init
    }
  },

  methods: {
    afterInit(res) {
      res.data.records.forEach(index => {
        index.outLowPrice = index.outLowPrice || 0
        index.inLowPrice = index.inLowPrice || 0
      })
      this.tableData = this.generateTableId(res.data.records, 0)
    },
    beforeInit() {
      this.tableUrl = '/webReportKeyword/Application/list'
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    changeDateFormatData(dateFormatId) {
      this.tableParams.showType = dateFormatId
      // if (dateFormatId === 0) {
      //   this.tableParams.showType = 0
      // } else if (dateFormatId !== 0) {
      //   this.tableParams.showType = dateFormatId
      //   this.tableData.forEach(index => {
      //     index.reportTime = this.tableParams.endTime
      //   });
      // }
    },
    load(tree, treeNode, resolve) {
      this.$nextTick(() => {
        const search = {
          appBundle: tree.appBundle,
          dspId: tree.dspId,
          oppoChannel: tree.oppoChannel,
          pageSize: this.pagination.pageSize,
          pageNum: this.pagination.pageNum,
          asc: this.tableParams.asc,
          desc: this.tableParams.desc,
          showType: this.tableParams.showType || 0,
        }
        if (tree.timeKey === undefined) {
          search.endTime = this.tableParams.endTime
          search.startTime = this.tableParams.startTime
        } else {
          search.endTime = tree.timeKey
          search.startTime = tree.timeKey
        }
        fetchApplicationDetailList(search).then(res => {
          if (res.code === 200) {
            // 子行关键字
            if (res.data.records[0]) {
              res.data.records.forEach(index => {
                index.oppoChannel = index.keyword || undefined
                let dspName = index.dspName || undefined
                this.$nextTick(() => {
                  index.dspName = dspName
                })
              })
              resolve(this.generateTableId(res.data.records, tree.id))
            } else {
              resolve(this.generateTableId(res.data.records, tree.id))
            }
          }
        })
      })
    },
    generateTableId(data, base) {
      if (!data) return []
      for (let i = 0; i < data.length; i++) {
        data[i].id = uuid()
        if (base === 0) {
          data[i].hasChildren = true
        } else {
          data[i].dspSlotCode = data[i].slotId
          data[i].dspName = data[i].channelName
          data[i].dspSlotName = data[i].slotName
        }
      }
      return data
    },
    sortChange(column, prop, order) {
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ""
      } else if (column.order === "descending") {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ""
      }
      this.init()
    },

    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },

    oncli(row, type) {
      this.type = type == 'expend' ? '支出' : '收入';
      this.$refs.form.show(row, type)
    },
    sizeChange(e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange(e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    removeBlank(val, name) {
      this.tableParams[name] = val.replace(/^\s+|\s+$/gm, '')
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
